import { PureComponent } from "react";
import { componentStyles } from "./bullets.scss";
import DefaultProps from "./default-props";
import BulletCheck from "/static/svg/checklist_checked.svg";

export default class Bullets extends PureComponent {
  renderBullet(bullet, bulletIndex) {
    return (
      <div className="bullet" key={bulletIndex}>
        <div className="bullet-icon">
          <BulletCheck />
        </div>
        <div className="bullet-text">{bullet.bulletText}</div>
      </div>
    );
  }

  render() {
    const { bullets } = this.props;

    if (!bullets) return null;

    return (
      <div className="bullets">
        {bullets.map((bullet, bulletIndex) => {
          return this.renderBullet(bullet, bulletIndex);
        })}

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

Bullets.defaultProps = DefaultProps;
